import React, { useState } from 'react';
import MetaTags from 'components/common/MetaTags';
import PageHeader from 'components/NewDesign/PageHeader';
import MainContent from 'components/NewDesign/MainContent';
import AthletePRsReport from 'components/admin/reports/AthletePRs';
import { exportAthletePrReportToFile, exportAthletePrReportToResultsHQ } from 'api/reportsApi';
import { useSelector } from 'react-redux';
import CustomNewButton from 'components/NewDesign/CustomNewButton';
import ExportFormatDialog from 'components/admin/ExportFormatDialog';
import { CSV_FORMAT_OPTIONS } from 'constants';
import { exportAndDownloadFile } from 'utils/fileDownload';
import useActiveSeasonName from 'hooks/useActiveSeasonName';

const AthletePRs = () => {
  const { selectedClub } = useSelector((state) => state.user || {});
  const [reportData, setReportData] = useState(null);
  const seasonName = useActiveSeasonName(selectedClub?.clubID);
  // Export to file asks for the file's format first: ResultsHQ Excel or SplitFast csv, by the
  // names Event View's export uses (Doug, 2026-10-25).
  const [showExportDialog, setShowExportDialog] = useState(false);
  const [exportFormat, setExportFormat] = useState(CSV_FORMAT_OPTIONS[0].value);

  const handleExportToFile = async () => {
    setShowExportDialog(false);
    const isResultsHQ = exportFormat === 'rhq_excel';
    await exportAndDownloadFile(
      isResultsHQ ? exportAthletePrReportToResultsHQ : exportAthletePrReportToFile,
      [{
        clubId: selectedClub.clubID,
        eventTypeCodes: reportData.eventTypeCodes,
        ageGroupAges: reportData.ageGroupAges,
        gender: reportData.selectedGender,
        pointsEligibleOnly: reportData.pointsEligibleOnly,
      }],
      '',
      'The athlete PR report was successfully exported',
      'Fetching athlete PR report data from the server...'
    );
  };

  const isExportButtonDisabled = !reportData || !reportData.hasData;

  return (
    <>
      <MetaTags title="SplitFast | Season Best Report" />
      <MainContent>
        <PageHeader title="Season Best Report" subTitle={seasonName} primarySubTitle>
          <CustomNewButton
            variant="info"
            onClick={() => setShowExportDialog(true)}
            label="Export to file"
            disabled={isExportButtonDisabled}
          />
        </PageHeader>
        {!selectedClub ? (
          <div style={{ minHeight: '100vh' }}/>
        ) : (
          <AthletePRsReport
            clubID={selectedClub.clubID}
            onDataChange={setReportData}
          />
        )}
      </MainContent>
      <ExportFormatDialog
        isOpen={showExportDialog}
        format={exportFormat}
        onFormatChange={setExportFormat}
        onExport={handleExportToFile}
        onClose={() => setShowExportDialog(false)}
      />
    </>
  );
};

export default AthletePRs;
